import React from 'react';
import { Link } from 'react-router-dom';

import styles from './footer.module.css';

export default function Footer({ fullFooter = true, bgColor = '#173959', columnHeaderStyles = null }) {
  return (
    <footer id={'site-footer'} className={styles.footer} style={{ backgroundColor: bgColor }}>
      <div className='container'>
        <div className={styles.footer_top}>
          <div className='row'>
            <div className='col-md-6 wow fadeInUp' data-wow-delay='0.2s'>
              <div className={styles.footer_innr}>
                <div className={styles.foot_logo}>
                  <Link to='/' className={styles.logo}>
                    {' '}
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/patient-partner-logo-light.png'
                      alt='patientpartnerlogo'
                      className='img-fluid'
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {fullFooter ? (
            <div className='row'>
              <div className='col-md-3' data-wow-delay='0.8s'>
                <div className={styles.footer_innr}>
                  <div className={styles.footer_menu}>
                    <p style={columnHeaderStyles}>For Patients</p>
                    <ul>
                      <li>
                        <Link to='/get-started/patient-partner-match'>Find a mentor</Link>
                      </li>
                      <li>
                        <Link to='/patient-partner-agreement'>Participation agreement</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-md-3' data-wow-delay='0.8s'>
                <div className={styles.footer_innr}>
                  <div className={styles.footer_menu}>
                    <p style={columnHeaderStyles}>For Mentors</p>
                    <ul>
                      <li>
                        <a href='/for-mentors' target='_blank' rel='noreferrer'>
                          Become a PatientPartner mentor
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-md-3' data-wow-delay='0.8s'>
                <div className={styles.footer_innr}>
                  <div className={styles.footer_menu}>
                    <p style={columnHeaderStyles}>Partner With Us</p>
                    <ul>
                      <li>
                        <a href='https://www.patientpartner.com'>Industry Partners</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className='col-md-3' data-wow-delay='0.6s'>
                <div className={styles.footer_innr}>
                  <div className={styles.footer_menu}>
                    <p style={columnHeaderStyles}>Our Company</p>
                    <ul>
                      <li>
                        <Link to='/contact-us'>Contact us</Link>
                      </li>
                      <li>
                        <Link to='/how-it-works'>How it works</Link>
                      </li>
                      <li>
                        <Link to='/press-room'>Press Room</Link>
                      </li>
                      <li>
                        <a target='_blank' rel='noopener noreferrer' href='https://careers.patientpartner.com'>
                          Careers
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        <div className={`${styles.footer_bottom} text-center`}>
          <div className='row'>
            <div className='col-md-9 wow fadeInUp' data-wow-delay='0.2s'>
              <p className={styles.copyright_txt}>
                &copy; {new Date().getFullYear()} rightdevice, Inc. dba PatientPartner All right reserved. |{' '}
                <Link to='/terms'>Terms of service</Link> | <Link to='/privacy'>Privacy policy</Link> |{' '}
                <Link to='/code-of-conduct'>Code of conduct</Link>
              </p>
            </div>
            {fullFooter && (
              <div className='col-md-3 wow fadeInUp' data-wow-delay='0.2s'>
                <div className={styles.socials}>
                  <a target='_blank' rel='noopener noreferrer' href='https://www.facebook.com/PatientPartner1'>
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/contact-us/facebook-w.svg'
                      aria-hidden='true'
                    />
                  </a>
                  <a target='_blank' rel='noopener noreferrer' href='https://twitter.com/patientpartner1'>
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/contact-us/twitter-w.svg'
                      aria-hidden='true'
                    />
                  </a>
                  <a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/patient_partner/'>
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/contact-us/instagram-w.svg'
                      aria-hidden='true'
                    />
                  </a>
                  <a target='_blank' rel='noopener noreferrer' href='https://in.linkedin.com/company/rightdevice'>
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/contact-us/linkedin-w.svg'
                      aria-hidden='true'
                    />
                  </a>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://www.youtube.com/channel/UC5EthG-VCW6xJ6RnTPaYUIQ'
                  >
                    <img
                      src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/contact-us/youtube-w.svg'
                      aria-hidden='true'
                    />
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
